import { Fragment } from "react";
import { translate } from "./mfb-labels";

function CodeTable({ heads, rows, t }) {
	return (
		<div className="tu-product-table-wrap">
			<table className="table table-hover table-striped table-bordered tu-seal-table">
				<thead>
					<tr className="inside-table-text">
						{heads.map((head) => (
							<th key={head}>{t(head)}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr className="inside-table-text" key={row.join("|")}>
							{row.map((cell, index) => (
								<td key={index}>{t(cell)}</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

function Section({ id, back, title, t, children }) {
	return (
		<>
			<h4 id={id}>
				<a href={back}>{t(title)}</a>
			</h4>
			{children}
		</>
	);
}

export default function MfbNumeroDeParte({ locale = "es" }) {
	const t = (value) => translate(locale, value);
	const id = "mfb";
	const back = (segment) => `#${id}-code-${segment}`;
	const code = [
		{ id: "sellos", code: "F3" },
		{ id: "serie", code: "MFB" },
		{ id: "caudal", code: "10" },
		{ id: "montaje", code: "F" },
		{ id: "rotacion", code: "U" },
		{ id: "eje", code: "Y" },
		{ id: "puertos", code: "(F)" },
		{ id: "diseno", code: "31" },
	];
	const legend = [
		{ id: "sellos", code: "F3", text: "Sellos especiales" },
		{ id: "serie", code: "MFB", text: "Serie del modelo" },
		{ id: "caudal", code: "10", text: "Caudal a 1800 rpm" },
		{ id: "montaje", code: "F", text: "Tipo de montaje" },
		{ id: "rotacion", code: "U", text: "Rotación" },
		{ id: "eje", code: "Y", text: "Extremo del eje" },
		{ id: "puertos", code: "(F)", text: "Conexiones de puerto" },
		{ id: "diseno", code: "31", text: "Número de diseño" },
	];

	return (
		<div className="tu-part-number">
			<img
				className="tu-part-number__photo tu-part-number__photo--mfb"
				src="/images/vickers_mfb_piston_motor/MFB_Piston_Motor.svg"
				alt={t("Motor de pistón MFB")}
				width={1623}
				height={948}
				loading="lazy"
				decoding="async"
			/>
			<h4>{t("Desglose del código de modelo")}</h4>
			<p className="tu-part-number__code">
				{code.map((segment, index) => (
					<span key={segment.id}>
						{index > 0 ? " " : null}
						<a id={`${id}-code-${segment.id}`} href={`#${id}-${segment.id}`}>
							{segment.code}
						</a>
					</span>
				))}
			</p>
			<dl className="tu-part-number__key tu-part-number__key--numbered">
				{legend.map((item, index) => (
					<Fragment key={item.id}>
						<dt className="tu-part-number__num">
							<a href={`#${id}-${item.id}`}>{index + 1}</a>
						</dt>
						<dt>
							<a href={`#${id}-${item.id}`}>{item.code}</a>
						</dt>
						<dd>{t(item.text)}</dd>
					</Fragment>
				))}
			</dl>

			<Section id={`${id}-sellos`} back={back("sellos")} title="Sellos especiales" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[
						["F3", "Viton"],
						["—", "Omitir si no se requiere"],
					]}
				/>
			</Section>

			<Section id={`${id}-serie`} back={back("serie")} title="Serie del modelo" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[
						["M", "Motor"],
						["F", "Desplazamiento fijo"],
						["B", "Tipo en línea"],
					]}
				/>
			</Section>

			<Section id={`${id}-caudal`} back={back("caudal")} title="Caudal a 1800 rpm" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Caudal"]}
					rows={[
						["5", "5 GPM (19 LPM)"],
						["10", "10 GPM (37.9 LPM)"],
						["20", "20 GPM (75.7 LPM)"],
						["29", "29 GPM (109.8 LPM)"],
						["45", "45 GPM (170.3 LPM)"],
					]}
				/>
			</Section>

			<Section id={`${id}-montaje`} back={back("montaje")} title="Tipo de montaje" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[
						["F", "Soporte de pie"],
						["—", "Omitir para montaje por brida"],
					]}
				/>
				<p>{t("Para el kit de soporte de pie por separado, consulte la página 13 de la literatura.")}</p>
			</Section>

			<Section id={`${id}-rotacion`} back={back("rotacion")} title="Rotación" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[["U", "Bidireccional"]]}
				/>
			</Section>

			<Section id={`${id}-eje`} back={back("eje")} title="Extremo del eje (solo MFB5/10)" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[
						["Y", "Eje estándar"],
						["—", "Eje opcional"],
					]}
				/>
				<p>
					{t(
						"* El eje opcional está disponible solo para intercambiar unidades de diseño anterior (-10). No se recomienda para operación por encima de 1800 RPM y 100 bar (1500 psi)."
					)}
				</p>
			</Section>

			<Section id={`${id}-puertos`} back={back("puertos")} title="Conexiones de puerto (MFB45)" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[["F", "Puertos con brida SAE de 4 pernos"]]}
				/>
			</Section>

			<Section id={`${id}-diseno`} back={back("diseno")} title="Número de diseño (sujeto a cambio)" t={t}>
				<CodeTable
					t={t}
					heads={["Código", "Descripción"]}
					rows={[
						["21", "Diseño 21 (MFB5)"],
						["31", "Diseño 31 (MFB10)"],
						["10", "Diseño 10 (MFB20, 29 y 45)"],
					]}
				/>
			</Section>
		</div>
	);
}
